module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/dislike-835697015f739f1146c952acde1f0500.svg";